"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateUserInfoFailure = exports.updateUserInfoSuccess = exports.updateUserInfoRequest = exports.toggleSearchDropdown = exports.searchUsersFailure = exports.searchUsersSuccess = exports.setSearchString = void 0;
const ActionTypes = require("../actionTypes/users");
function setSearchString(searchString) {
    return {
        type: ActionTypes.SET_SEARCH_STRING,
        searchString
    };
}
exports.setSearchString = setSearchString;
function searchUsersSuccess(data) {
    return {
        type: ActionTypes.SEARCH_USERS_SUCCESS,
        data
    };
}
exports.searchUsersSuccess = searchUsersSuccess;
function searchUsersFailure(error) {
    return {
        type: ActionTypes.SEARCH_USERS_FAILURE,
        error
    };
}
exports.searchUsersFailure = searchUsersFailure;
function toggleSearchDropdown(flag) {
    return {
        type: ActionTypes.TOGGLE_SEARCH_DROPDOWN,
        flag
    };
}
exports.toggleSearchDropdown = toggleSearchDropdown;
function updateUserInfoRequest(id, data) {
    return {
        type: ActionTypes.UPDATE_USER_INFO_REQUEST,
        id,
        data
    };
}
exports.updateUserInfoRequest = updateUserInfoRequest;
function updateUserInfoSuccess(user) {
    return {
        type: ActionTypes.UPDATE_USER_INFO_SUCCESS,
        user
    };
}
exports.updateUserInfoSuccess = updateUserInfoSuccess;
function updateUserInfoFailure() {
    return {
        type: ActionTypes.UPDATE_USER_INFO_FAILURE
    };
}
exports.updateUserInfoFailure = updateUserInfoFailure;
//# sourceMappingURL=users.js.map